export default {
  error404: {
    heading: 'Oops, mi dispiace!',
    notFound: 'Il sondaggio che stavi cercando non esiste o è stato spostato.'
  }
};